<template>
  <div
    v-if="itemId"
    class="widget-danger"
  >
    <p
      v-if="responseCode !== 1"
      class="notification-text"
      v-html="$translate('Ecomsilio::Template.availabilityNotification')"
    />
    <template v-if="responseCode >= 1 && responseCode <= 6">
      <p
        v-if="responseCode === 1"
        class="notification-success"
      >
        {{ $translate("Ecomsilio::Template.availabilityNotificationMessage1") }}
      </p>
      <p
        v-else-if="responseCode === 2"
        class="notification-error"
      >
        {{ $translate("Ecomsilio::Template.availabilityNotificationMessage2") }}
      </p>
      <p
        v-else-if="responseCode === 3"
        class="notification-error"
      >
        {{ $translate("Ecomsilio::Template.availabilityNotificationMessage3") }}
      </p>
      <p
        v-else-if="responseCode === 5"
        class="notification-error"
      >
        {{ $translate("Ecomsilio::Template.availabilityNotificationMessage5") }}
      </p>
      <p
        v-else-if="responseCode === 6"
        class="notification-error"
      >
        {{ $translate("Ecomsilio::Template.availabilityNotificationMessage6") }}
      </p>
      <p
        v-else-if="responseCode === 9"
        class="notification-error"
      >
        {{ $translate("Ecomsilio::Template.availabilityNotificationMessage6") }}
      </p>
    </template>
    <form
      v-if="responseCode !== 1"
      ref="availabilityNotificationForm"
      autocomplete="on"
      method="post"
      class="row mb-3"
      @submit.prevent="validateNotificationForm()"
    >
      <div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 mb-3 mb-sm-0 mb-md-3 mb-lg-0 pr-lg-2">
        <input
          v-model="username"
          data-validate="mail"
          name="email"
          required="required"
          type="email"
          :placeholder="$translate('Ceres::Template.contactMail')"
          class="form-control"
          aria-required="true"
          :aria-label="$translate('Ceres::Template.contactMail')"
          autocomplete="email"
          :disabled="isSendingData"
          @focus="loadRecaptcha = true"
        >
      </div>
      <div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 pl-lg-0">
        <button
          class="btn btn-block btn-default btn-appearance"
          :aria-label="$translate('Ecomsilio::Template.availabilityNotificationSubmitButton')"
        >
          <icon
            icon="fa-paper-plane-o"
            :loading="isSendingData"
          />
          {{ $translate("Ecomsilio::Template.availabilityNotificationSubmitButton") }}
        </button>
      </div>
      <recaptcha v-if="!!googleRecaptchaApiKey && loadRecaptcha" />
    </form>
    <hr class="widget widget-separator mb-3 clearboth">
  </div>
</template>
<script>
export default {
    name: "BwAvailabilityNotification",
    props: {
        itemId: Number,
        variationId: Number,
        language: {
            type: String,
            default: "de"
        }
    },
    data ()
    {
        return {
            username: "",
            googleRecaptchaApiKey: App.config.global.googleRecaptchaApiKey,
            responseCode: 0,
            isSendingData: false,
            loadRecaptcha: false
        }
    },
    computed: {
        articleName ()
        {
            return this.$store.getters[this.itemId + "/currentItemVariation"].texts.name1
        },
        variationAttributes ()
        {
            let attributeString = ""

            if (this.$store.getters[this.itemId + "/currentItemVariation"].attributes.length > 0)
            {
                this.$store.getters[this.itemId + "/currentItemVariation"].attributes.forEach(function (attribute)
                {
                    attributeString = attributeString + attribute.attribute.names.name + ": " + attribute.value.names.name + "; "
                })
            }
            return attributeString
        },
        urlPath ()
        {
            return this.$store.getters[this.itemId + "/currentItemVariation"].texts.urlPath + "_" + this.itemId + "_" + this.variationId
        },
        imagePath ()
        {
            if (this.$store.getters[this.itemId + "/currentItemVariation"].images.variation.length > 0)
            {
                return this.$store.getters[this.itemId + "/currentItemVariation"].images.variation[0].path
            }
            return this.$store.getters[this.itemId + "/currentItemVariation"].images.all[0].path
        }
    },
    watch: {
        variationId ()
        {
            this.responseCode = 0
        }
    },
    methods: {
        resetRecaptcha ()
        {
            if (App.config.global.googleRecaptchaVersion === 2 && window.grecaptcha)
            {
                const recaptchaId = this.$refs.availabilityNotificationForm.querySelector("[data-recaptcha]")

                window.grecaptcha.reset(recaptchaId)
            }
        },
        executeReCaptcha (form)
        {
            let response = Promise.resolve(null)
            const recaptchaElement = form.querySelector("[data-recaptcha]")

            if (window.grecaptcha && recaptchaElement)
            {
                response = new Promise((resolve, reject) =>
                {
                    if (App.config.global.googleRecaptchaVersion === 3)
                    {
                        window.grecaptcha.execute(
                            App.config.global.googleRecaptchaApiKey,
                            { action: "homepage" }
                        ).then(response =>
                        {
                            if (response)
                            {
                                resolve(response)
                            }
                            else
                            {
                                reject()
                            }
                        })
                    }
                    else
                    {
                        window.grecaptcha.execute(recaptchaElement.dataset.recaptcha)
                        recaptchaElement.querySelector("[name=\"g-recaptcha-response\"]").addEventListener("recaptcha-response", (evt) =>
                        {
                            if (evt.target.value)
                            {
                                resolve(evt.target.value)
                            }
                            else
                            {
                                window.grecaptcha.reset(recaptchaElement.dataset.recaptcha)
                                reject()
                            }
                        })
                    }
                })
            }
            return response
        },
        sendNotificationData (recaptcha)
        {
            const settings = {
                url: "https://verfuegbarkeit.bw-mehr.de/bw-verfuegbarkeit/insertdata.php",
                method: "POST",
                timeout: 0,
                crossDomain: true,
                headers: { "Content-Type": "application/json" },
                data: JSON.stringify({
                    mail: this.username,
                    item_id: this.itemId,
                    var_id: this.variationId,
                    lang: this.language,
                    art_name: this.articleName,
                    imagePath: this.imagePath,
                    urlPath: this.urlPath,
                    variationAttributes: this.variationAttributes
                })
            }

            $.ajax(settings).done(result => this.responseCode = parseInt(result)).done(result => this.isSendingData = false).fail(result => this.responseCode = 9).then(this.resetRecaptcha())
        },
        validateNotificationForm ()
        {
            // ggf. Ergänzung hinzufügen:
            // const recaptchaEl = this.$el.querySelector("[data-recaptcha]");
            // if (App.config.global.googleRecaptchaApiKey && (!window.grecaptcha || !recaptchaEl))
            // {
            //   NotificationService.error(this.$translate("Ceres::Template.newsletterAcceptRecaptchaCookie"));
            //   this.isDisabled = false;
            //   return;
            // }
            this.isSendingData = true
            this.executeReCaptcha(this.$refs.availabilityNotificationForm).then((recaptchaToken) =>
            {
                this.sendNotificationData(recaptchaToken)
                this.resetRecaptcha()
            })
        }
    }
}
</script>
